import {Injectable} from '@angular/core';
import {AbstractLiveDataService} from './abstract-live-data.service';
import {PaperType} from '../../model/PaperType';
import {HttpClient} from '@angular/common/http';
import {StartupService} from '../service-ui/startup.service';
import {NotificationsService} from './notifications.service';
import {MessageService} from "../service-ui/message.service";

@Injectable({
  providedIn: 'root'
})
export class PaperTypeService extends AbstractLiveDataService<PaperType> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    this.notificationsService.setPaperTypeService(this);
    this.notificationsService.startNotification();
  }

  makeObjectInstance(args: any): PaperType {
    const object = new PaperType(args);
    return object;
  }

  getLoggingObjectTypeName (): string {
    return "PaperType";
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint (): string {
    return "papertype";
  }

  getLinkData(): any[] {
    return [];
  }
}

